import { CommonModule } from '@angular/common';
import { Component, InputSignal, OnInit, input, model } from '@angular/core';
import { FormsModule } from '@angular/forms';

export interface SelectOption {
  value: string;
  label: string;
}

@Component({
  selector: 'lib-select',
  imports:[CommonModule, FormsModule],
  templateUrl: './select.component.html',
})
export class SelectComponent implements OnInit {

  options: InputSignal<SelectOption[]> = input<SelectOption[]>([]);
  placeholder = input('Selecciona una opción');
  className = input('');
  defaultValue = input('');
  value = model('');
  disabled = input(false);   

  ngOnInit() {
    if (!this.value() && this.defaultValue()) {
      this.value.set(this.defaultValue());
    }
  }

  onChange(event: Event) {
    const value = (event.target as HTMLSelectElement).value;
    this.value.set(value);
  }
}